<template>
    <div>
        <navbar/>
        <main role="main" >
            <div class="jumbotron" id="tl-jumbotron">
                <div class="container">
                    <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
                        <h4 class="col-12 mb-4"><span class="bi bi-bug text-info mr-2"/>UA parsing test</h4>
                    </div>
                    <div  class="row tl-link-block p-4">
                        <div class="col-12">
                            <code>
                            <pre>{{ JSON.stringify(uaResult, null, 2) }}</pre>
                            </code>
                        </div>
                        <div class="col-12">
                            Browser name: {{ uaResult?.browser?.name }}
                        </div>
                        <div class="col-12">
                            mobile: {{ isMobile ? "yes" : "no"  }}
                        </div>
                    </div>

                </div>
            </div>
        </main>
        <tlfooter />
    </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import { UAParser } from 'ua-parser-js';


export default {
    name: "UAParser",
    components: { navbar, tlfooter },
    data() {
        return {
            UAParser: new UAParser(),
            uaResult: ""
        };
    },

    mounted() {
        this.uaResult = this.UAParser.getResult();
    },

    computed: {
        isMobile() {
            return this.uaResult?.device?.type === 'mobile'
        }
    },

    methods: {

    }
};
</script>
<style>

</style>
